/** Tipos do sistema genético — base em U1, breed/lineage em U2. */

export type AlchemyType = 'Fire' | 'Water' | 'Earth' | 'Air' | 'Life' | 'Shadow';

export const ALL_ALCHEMY_TYPES: ReadonlyArray<AlchemyType> = [
  'Fire',
  'Water',
  'Earth',
  'Air',
  'Life',
  'Shadow',
];

export type BodyGene = 'round' | 'tall' | 'ghost' | 'blob' | 'fish';
export const ALL_BODY_GENES: ReadonlyArray<BodyGene> = ['round', 'tall', 'ghost', 'blob', 'fish'];

export type EyesGene = 'basic';
export const ALL_EYES_GENES: ReadonlyArray<EyesGene> = ['basic'];

export type MouthGene = 'basic';
export const ALL_MOUTH_GENES: ReadonlyArray<MouthGene> = ['basic'];

export type EarGene = 'round' | 'pointy' | 'floppy' | 'antenna';
export const ALL_EAR_GENES: ReadonlyArray<EarGene> = ['round', 'pointy', 'floppy', 'antenna'];

export type HornGene = 'none' | 'nub' | 'twin' | 'crown';
export const ALL_HORN_GENES: ReadonlyArray<HornGene> = ['none', 'nub', 'twin', 'crown'];

export type TailGene = 'none' | 'stub' | 'curl' | 'fin';
export const ALL_TAIL_GENES: ReadonlyArray<TailGene> = ['none', 'stub', 'curl', 'fin'];

export type MarkingGene = 'none' | 'cheeks' | 'freckles' | 'stripes' | 'mask';
export const ALL_MARKING_GENES: ReadonlyArray<MarkingGene> = [
  'none',
  'cheeks',
  'freckles',
  'stripes',
  'mask',
];

export type EggPatternGene =
  | 'plain'
  | 'spots'
  | 'patches'
  | 'stripes'
  | 'dots'
  | 'checks'
  | 'stars'
  | 'dark';

export const ALL_EGG_PATTERNS: ReadonlyArray<EggPatternGene> = [
  'plain',
  'spots',
  'patches',
  'stripes',
  'dots',
  'checks',
  'stars',
  'dark',
];

/** Modificador genético secundário (U2 popula com efeitos reais). */
export interface GeneticModifier {
  id: string;
}

export interface RecessiveGenes {
  body?: BodyGene;
  ears?: EarGene;
  horns?: HornGene;
  tail?: TailGene;
  markings?: MarkingGene;
  eggPattern?: EggPatternGene;
}

/** Traço evolutivo herdável adquirido em runs roguelite (U5). */
export interface EvolutionTrait {
  id: string;
  rarity: 'common' | 'rare' | 'epic';
  inheritedFrom: string | null;
}

export interface Genome {
  body: BodyGene;
  eyes: EyesGene;
  mouth: MouthGene;
  ears: EarGene;
  horns: HornGene;
  tail: TailGene;
  markings: MarkingGene;
  /** Hue em [0..359] (HSL). */
  paletteHue: number;
  /** Herança fraca (~20%) do resultado de evolução dos pais; 50 = neutro. */
  bodyPredisposition: number;
  eggPattern: EggPatternGene;
  /** 1..3 tipos elementais. */
  primaryTypes: AlchemyType[];
  modifiers: GeneticModifier[];
  inheritedTraits: EvolutionTrait[];
  recessiveGenes?: RecessiveGenes;
}
